const Trix = require("trix");
require("@rails/actiontext");
